export enum YesNoEnum {
    Yes = 1,
    No = 0,
}

export enum NoYesEnum {
    No = 0,
    Yes = 1,
}

export enum RegistrationType {
    Individual = "INDIVIDUAL",
    'Institute/Organization' = "INSTITUTE/ORGANIZATION",
}